import { createBrowserHistory } from 'history'

import { configureStore } from './configure-store'

import featureFlags from '../utils/featureFlags'

const initialState = { app: featureFlags.getFeatureFlags() }

const history = createBrowserHistory()
const store = configureStore(initialState, history)

export { history, store }
